export const CompanyType = Object.freeze({
    FIRE_AND_RESCUE: 'Fire and Rescue',
    POLICE: 'Police',
    NHS: 'NHS',
});
